import { render, staticRenderFns } from "./a-link-v2.vue?vue&type=template&id=21518b81&scoped=true&v-if=href"
import script from "./a-link-v2.vue?vue&type=script&lang=js"
export * from "./a-link-v2.vue?vue&type=script&lang=js"
import style0 from "./a-link-v2.vue?vue&type=style&index=0&id=21518b81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21518b81",
  null
  
)

export default component.exports